function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3f17177d\",\"scoped\":false,\"hasInlineConfig\":false}!autoprefixer-loader!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./mainPrice.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./mainPrice.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3f17177d\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./mainPrice.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/mainPrice.vue
// module id = 42
// module chunks = 0